import { Button as NavButtons } from '@progress/kendo-react-buttons';
import GuideMeTitleBar from 'src/components/GuideMeTitleBar';
import Button from 'src/components/design-system/Button';
import CircularIconButton from 'src/components/design-system/CircularIconButton';

const BasicPageNavigation = () => (
  <ul className="px-4 font-bold text-[13px]">
    <li className="list-disc font-semibold">
      Click the <CircularIconButton icon="arrow-end-right" />
      and <CircularIconButton icon="arrow-end-left" /> buttons to view data from the next or
      previous departments, respectively
    </li>
    <li className="list-disc font-semibold">
      The <CircularIconButton icon="arrow-end-left" /> button will be disabled when there are no
      departments prior to selected department in the dropdown
    </li>
    <li className="list-disc font-semibold">
      The <CircularIconButton icon="arrow-end-right" /> button will be disabled when there are no
      departments next to the selected department in the drop down
    </li>
    <li className="list-disc font-semibold">
      Enter text in the search box to search from both Unassigned and Assigned lists
    </li>
  </ul>
);

const EditGLCodesOrMembers = () => (
  <ul className="px-4 font-bold text-[13px]">
    <li className="list-disc font-semibold">
      Click the checkbox in the header row to select all items
    </li>
    <li className="list-disc font-semibold">
      Click
      <NavButtons
        size={'small'}
        icon={'caret-double-alt-right'}
        className="m-1"
        style={{ pointerEvents: 'none' }}
      />
      to assign all items.
    </li>
    <li className="list-disc font-semibold">
      Click
      <NavButtons
        size={'small'}
        icon={'caret-double-alt-left'}
        className="m-1"
        style={{ pointerEvents: 'none' }}
      />
      to unassign all items.
    </li>
    <li className="list-disc font-semibold">
      Select one or more items and click on
      <NavButtons
        size={'small'}
        icon={'caret-alt-right'}
        className="mx-1"
        style={{ pointerEvents: 'none' }}
      />
      to assign the selected item(s)
    </li>
    <li className="list-disc font-semibold">
      Select one or more items and click on
      <NavButtons
        size={'small'}
        icon={'caret-alt-left'}
        className="mx-1 "
        style={{ pointerEvents: 'none' }}
      />
      to unassign the selected item(s)
    </li>

    <li className="list-disc font-semibold">
      Buttons will be disabled when one or more ineligible items have been selected for the action
    </li>
    <li className="list-disc font-semibold">
      Click{' '}
      <Button color="info" className="inline-block" size="lg" readonly={true}>
        Add From Other Department
      </Button>{' '}
      button to add GL Codes, Members from other department to selected department
    </li>
  </ul>
);
const SaveDiscardContent = () => (
  <ul className="px-4 font-bold text-[13px]">
    <li className="list-disc font-semibold">
      Click
      <Button color="success" className="inline-block" size="lg" readonly={true}>
        Save
      </Button>
      to save changes
    </li>
    <li className="list-disc font-semibold">
      Click
      <Button color="info" className="inline-block" size="lg" readonly={true}>
        Back
      </Button>
      to navigate to the View/Edit Departments page
    </li>
    <li className="list-disc font-semibold">
      Clicking
      <Button color="info" className="inline-block" size="lg" readonly={true}>
        Cancel
      </Button>
      will discard changes and navigate to the View/Edit Departments page
    </li>
  </ul>
);

const useManageDepartmentsGuideMeSteps = () => [
  {
    title: (
      <GuideMeTitleBar title={'Basic Page Navigation'} className="font-bold text-xl text-red-600" />
    ),
    content: <BasicPageNavigation />,
  },
  {
    title: (
      <GuideMeTitleBar
        title={'Edit GL Codes or Members'}
        className="font-bold text-xl text-red-600"
      />
    ),
    content: <EditGLCodesOrMembers />,
  },
  {
    title: <GuideMeTitleBar title={'Save or Discard'} className="font-bold text-xl text-red-600" />,

    content: <SaveDiscardContent />,
  },
];

export default useManageDepartmentsGuideMeSteps;
